<template>
    <div style="height: 100vh;">
      <div id="videoContainer" ref="playerContainer" class="player"></div>
    </div>
  </template>
  
  <script>
  import OvenPlayer from 'ovenplayer';
  import WebRtcStreamApi from '@/api/webrtc/WebRtcStreamApi';
  
  export default {
    data() {
      return {
        playerInstance: null,
        playerOption: null,
        demoOption: null,
        streamUrl: null,
      };
    },
    async created(){
        const frontPreUrl = window.location.protocol + '//' + window.location.host;
        const localurl = window.location.href;
      
        const tmpNumber = localurl.replace(frontPreUrl + '/streamPlayer?', ''); // base_url=wss::
      

        await this.setSecurity(tmpNumber);
        this.loadPlayer();
    },
    mounted() {
      
    },
    methods: {
        b64UrlEnc(str){
            return btoa(str) 
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, ''); 
        },
        async setSecurity(tmpNumber){
            // const tmp = tmpNumber.split("=")[1] || "";
            // const match = decodeURIComponent(tmp).match(/(wss:\/\/[^?]+)/);
            // const sourcefile = match ? `${match[1]}` : null;    // wss::
            const tmp = tmpNumber.match(/^base_url=(.+)$/)?.[1] || "";
            // console.log("tmp : ", tmp)
        
            this.streamUrl = tmp;
           
            this.initSetting();
        },

        initSetting() {
          
            this.playerOption = {
                autoStart: true,
                autoFallback: true,
                mute: true,
                sources: [],
                doubleTapToSeek: false
            };
            if (this.streamUrl) {
                // console.log("streamUrl => ", this.streamUrl)
                this.playerOption.sources.push({ type: "webrtc", file: decodeURIComponent(this.streamUrl) });
            }
        },

        loadPlayer(){
            if(this.playerInstance){
                this.playerInstance.remove();
                this.playerInstance = null;
            }

            // console.log("playerOption => ", this.playerOption)
            if(this.playerOption.sources.length == 0){
                return;
            }

            const option = JSON.parse(JSON.stringify(this.playerOption));
            // console.log('sources : ', this.playerOption.sources);

            this.playerInstance = OvenPlayer.create('videoContainer', option);

            this.playerInstance.on('ready', () => {
                console.log('Player ready.');

                setTimeout(() => {
                    this.playerInstance.play();
                }, 300);
            });

            this.playerInstance.once('error', (e) => {
                console.log("err => ", e);

                setTimeout(() => {
                    this.playerInstance.play();
                }, 300);
            });
        },
    },
    beforeDestroy() {
        if (this.playerInstance) {
            this.playerInstance.destroy();
        }
    },
  };
  </script>
  
  <style>
#videoContainer {
  --op-accent-color: red;
  height: 100%;
}
  </style>
  